import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { AnalyticsPageName, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const WhitelabelHelperTooltip = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);

  return (
    <HelperTooltip
      analyticsPageName={AnalyticsPageName.BILLING}
      analyticsFieldName={t("tooltips.whitelabel_title")}
      description={t("tooltips.whitelabel_description")}
      containerStyle={{ marginLeft: 6 }}
      maxWidth={300}
    />
  );
};

export default WhitelabelHelperTooltip;
